import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChallengeRegistrationComponent } from './features/shared/pages/challenge-registration/challenge-registration.component';
import { FitnessOrdersComponent } from './features/commerce/components/orders/fitness-orders.component';
import { FitnessStoreComponent } from './features/shared/pages/store/store.component';
import { StreakerCentralComponent } from './features/streaker-central/streaker-central.component';
import { CentralDashboardComponent } from './features/streaker-central/central-dashboard.component';
import { CentralLegacyRedirectComponent } from './features/streaker-central/central-legacy-redirect.component';
import { CentralTeamsPageComponent, CentralStatsPageComponent, CentralStreakersComponent } from './features/streaker-central/central-pages.components';
import { FitnessUserProfileComponent } from './features/user-profile/fitness-user-profile.component';
import { FITNESS_PROFILE_CONFIG_PART } from './features/user-profile/user-profile.config';
import { TeamProfileComponent } from './features/teams/components/team-profile/team-profile.component';
import { ParticipantProfileComponent } from './features/user-profile/participant-profile.component';
import {
  DwAuthGuardService,
  DwCanDeactivateGuard,
  DwRouteGuardUtil,
  DwUserRegistrationComponent,
} from '@devwareapps/devware-cap';

import { FitnessCheckoutPageComponent } from './features/commerce/components/checkout/fitness-checkout-page.component';
import { FitnessLoginComponent } from './features/shared/pages/login/fitness-login.component';
import { RecipientsPageComponent } from './features/recipients/components/recipients-page.component';
import { RecipientDetailComponent } from './features/recipients/components/recipient-detail.component';

const routes: Routes = [
  { path: 'streakers/Welcome', component: CentralLegacyRedirectComponent,
    data: { routeId: 'legacy-welcome', centralRedirect: 'registration', showInMenu: false, requireAuthentication: false } },
  { path: 'streakers/welcome', component: CentralLegacyRedirectComponent,
    data: { routeId: 'legacy-welcome-lowercase', centralRedirect: 'registration', showInMenu: false, requireAuthentication: false } },
  { path: 'recipients/previous', component: RecipientsPageComponent,
    data: { routeId: 'previous-recipients', display: 'Previous recipients', previous: true, showInMenu: false, requireAuthentication: false },
    children: [{ path: ':slug', component: RecipientDetailComponent,
      data: { routeId: 'previous-recipient-slug', display: 'Recipient story', showInMenu: false, requireAuthentication: false } },
      { path: ':challengeId/:slug', component: RecipientDetailComponent,
      data: { routeId: 'previous-recipient-story', display: 'Recipient story', showInMenu: false, requireAuthentication: false } }] },
  { path: 'recipients', component: RecipientsPageComponent,
    data: { routeId: 'recipients', display: 'Recipients', showInMenu: false, requireAuthentication: false },
    children: [{ path: ':slug', component: RecipientDetailComponent,
      data: { routeId: 'recipient-slug', display: 'Recipient story', showInMenu: false, requireAuthentication: false } },
      { path: ':challengeId/:slug', component: RecipientDetailComponent,
      data: { routeId: 'recipient-story', display: 'Recipient story', showInMenu: false, requireAuthentication: false } }] },
  { path: 'account/profile', component: FitnessUserProfileComponent, canDeactivate: [DwCanDeactivateGuard],
    data: {routeId: 'fitness-account-profile', display: 'My Profile', showInMenu: false, requireAuthentication: true,
      streakAgnostic: true, componentConfig: {configKeyPart: 'fitness-account-profile'}} },
  // CAP sorts the merged routes by menu order. Keep page URLs ahead of stored
  // menu actions that may use the same path (for example the My Orders action).
  { path: 'store/orders/:orderId', component: FitnessOrdersComponent,
    data: {routeId: 'fitness-order-details', display: 'Order details', routeOrder: -101, showInMenu: false, requireAuthentication: true, streakAgnostic: true} },
  { path: 'store/orders', component: FitnessOrdersComponent,
    data: {routeId: 'fitness-orders', display: 'My orders', routeOrder: -100, showInMenu: false, requireAuthentication: true, streakAgnostic: true} },
  { path: 'store', component: FitnessStoreComponent,
    data: { routeId: 'fitness-store', display: 'Store', showInMenu: false, requireAuthentication: false } },
  { path: 'user-profile/:slug', component: CentralLegacyRedirectComponent,
    data: { routeId: 'legacy-streaker-profile', centralRedirect: 'streaker', showInMenu: false, requireAuthentication: true } },
  { path: 'streaks/:challengeId/teams/:slug', component: CentralLegacyRedirectComponent,
    data: { routeId: 'legacy-team-slug', centralRedirect: 'team-slug', showInMenu: false, requireAuthentication: true } },
  { path: 'checkout', component: FitnessCheckoutPageComponent,
    data: { routeId: 'fitness-checkout', display: 'Checkout', showInMenu: false,
      referenceKey: 'fitness-checkout', requireAuthentication: true } },
  { path: 'teams', component: CentralLegacyRedirectComponent,
    data: { routeId: 'legacy-teams', centralRedirect: 'teams', showInMenu: false, requireAuthentication: true } },
  { path: 'teams/:teamId', component: CentralLegacyRedirectComponent,
    data: { routeId: 'legacy-team-id', centralRedirect: 'team-id', showInMenu: false, requireAuthentication: true } },
  { path: 'my-profile', component: CentralLegacyRedirectComponent,
    data: { routeId: 'legacy-my-profile', centralRedirect: 'own-profile', showInMenu: false, requireAuthentication: true } },
  { path: 'streaker-central', component: StreakerCentralComponent,
    data: { routeId: 'streaker-central', display: 'Streaker Central', showInMenu: false,
      referenceKey: 'streaker-central', requireAuthentication: true },
    children: [
      { path: '', pathMatch: 'full', component: CentralDashboardComponent,
        data: { routeId: 'central-dashboard', display: 'Dashboard', showInMenu: false, requireAuthentication: true } },
      { path: 'teams/id/:teamId', component: TeamProfileComponent, canDeactivate: [DwCanDeactivateGuard],
        data: { routeId: 'central-team-profile', display: 'Team profile', showInMenu: false, requireAuthentication: true } },
      { path: 'teams/:challengeId/:slug', component: TeamProfileComponent, canDeactivate: [DwCanDeactivateGuard],
        data: { routeId: 'central-team-profile-slug', display: 'Team profile', showInMenu: false, requireAuthentication: true } },
      { path: 'teams/:slug', component: TeamProfileComponent, canDeactivate: [DwCanDeactivateGuard],
        data: { routeId: 'central-team-profile-selected-streak', display: 'Team profile', showInMenu: false, requireAuthentication: true } },
      { path: 'teams', component: CentralTeamsPageComponent,
        data: { routeId: 'central-teams', display: 'Teams', showInMenu: false, requireAuthentication: true } },
      { path: 'streakers/my-profile', component: FitnessUserProfileComponent, canDeactivate: [DwCanDeactivateGuard],
        data: { routeId: 'my-profile', display: 'My profile', showInMenu: false, referenceKey: 'my-profile',
          requireAuthentication: true, componentConfig: { configKeyPart: FITNESS_PROFILE_CONFIG_PART } } },
      { path: 'streakers/:slug', component: ParticipantProfileComponent, canDeactivate: [DwCanDeactivateGuard],
        data: { routeId: 'central-streaker-profile', display: 'Streaker profile', showInMenu: false, requireAuthentication: true } },
      { path: 'streakers', component: CentralStreakersComponent,
        data: { routeId: 'central-streakers', display: 'Streakers', showInMenu: false, requireAuthentication: true } },
      { path: 'stats', component: CentralStatsPageComponent,
        data: { routeId: 'central-stats', display: 'Stats', showInMenu: false, requireAuthentication: true } },
      { path: 'leaderboards', pathMatch: 'full', redirectTo: 'stats' },
    ] },
  { path: 'challenge-registration', component: ChallengeRegistrationComponent,
    data: { routeId: 'challenge-registration', display: 'Challenge Registration', showInMenu: false,
      referenceKey: 'challenge-registration', requireAuthentication: true } },
  {
    path: 'login',
    component: FitnessLoginComponent,
    data: {
      routeId: 'login',
      display: 'Login',
      showInMenu: false,
      referenceKey: 'login',
    },
  },
  {
    path: 'register',
    component: DwUserRegistrationComponent,
    data: {
      routeId: 'register',
      display: 'Register',
      showInMenu: false,
      referenceKey: 'register',
    },
  },
  // TODO: Add custom Angular routes only if a feature requires a component outside the CAP routing system.
  // Teams, challenges, activities, users — all routed and rendered via CAP page configuration.
  {
    path: '**',
    redirectTo: '',
    data: { showInMenu: false },
  },
];

DwRouteGuardUtil.secureRoutes(routes, DwAuthGuardService);

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
